<template>
    <div class="m-sheet-root">
        <transition name="m-sheet-fade">
            <div class="m-sheet__mask" v-show="value" @click="close"></div>
        </transition>
        <transition name="m-sheet-slide">
            <div class="m-sheet" v-show="value">
                <div class="m-sheet__head" v-if="title || sub">
                    <div class="m-sheet__title" v-if="title">{{ title }}</div>
                    <div class="m-sheet__sub" v-if="sub">{{ sub }}</div>
                </div>
                <div class="m-sheet__actions" v-if="actions && actions.length">
                    <div
                        class="m-sheet__action"
                        :class="[a.color ? 'is-' + a.color : '', { 'is-disabled': a.disabled }]"
                        v-for="(a, i) in actions"
                        :key="a.key || i"
                        @click="pick(a)"
                    >
                        <i :class="a.icon || 'el-icon-menu'"></i>
                        <span>{{ a.label }}</span>
                    </div>
                </div>
                <slot></slot>
                <div class="m-sheet__cancel" @click="close">取消</div>
            </div>
        </transition>
    </div>
</template>

<script>
/* eslint-disable */
/**
 * m-sheet —— 手机端底部动作面板（ActionSheet）
 *
 * <m-sheet v-model="visible" title="操作" :actions="actions" @select="onSelect" />
 * actions: [{ key: 'edit', label: '编辑', icon: 'el-icon-edit', color: 'blue' }]
 * color 可选：blue / green / orange / purple / yellow / cyan / danger
 */
export default {
    name: 'MSheet',
    props: {
        value: { type: Boolean, default: false },
        title: { type: String, default: '' },
        sub: { type: String, default: '' },
        actions: { type: Array, default: () => [] },
    },
    methods: {
        close() {
            this.$emit('input', false);
        },
        pick(a) {
            if (a.disabled) return;
            this.$emit('input', false);
            this.$emit('select', a.key, a);
        },
    },
};
</script>
